const EXCEPTIONAL_CIRCUMSTANCES = 'exceptionalCircumstances';
export default EXCEPTIONAL_CIRCUMSTANCES;
